import ZpayKitLoader from './ZpayKitLoader';

export default ZpayKitLoader;
